import { all, Hr, Button, Checkbox, Div, H3, Label, RangeInput, reactive, Span, VArray } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import { patch } from 'tools/request'
import Icon from 'components/Icon'
import app from 'app/app'
import './AutoSelectDialog.scss'
import { currentAnalysisSelections } from 'model/SearchQuery'
import { track } from 'components/tracking/track'

export let selectAllMode = 'none'
export let selectAllModeVar = reactive('none')

export let singleGroupSelectionVar = currentAnalysisSelections.settings.singleGroupSelection
let selectAll, clearSelection
export function setSelectAll(newSelectAll, newClearSelection) {
	selectAll = newSelectAll
	clearSelection = newClearSelection
}
let alwaysUse = reactive(false)
let autoSelectThreshold = reactive(20)
let multiGroupPooling = reactive(false)
let additiveInterventions = reactive(false)
let includeSingleGroups = reactive(false)
let weightedAutoSelection = reactive(false)
let doAutoSelection = reactive(false)
let turnOnAutomaticAutoSelect = reactive(false)
function setMode(threshold) {
	selectAllMode = doAutoSelection.valueOf() ?
		weightedAutoSelection.valueOf() ? 'weighted' : 'select' : 'none'
	selectAllModeVar.put(selectAllMode)
	currentAnalysisSelections.settings.autoSelectMode.put(selectAllMode)
	currentAnalysisSelections.settings.autoSelectThreshold.put(threshold)
	currentAnalysisSelections.settings.multiGroupPooling.put(multiGroupPooling.valueOf())
	currentAnalysisSelections.settings.additiveInterventions.put(additiveInterventions.valueOf())
	currentAnalysisSelections.settings.singleGroupSelection.put(includeSingleGroups.valueOf())
	track({ event: 'auto-select-' + selectAllMode, threshold})
	if (selectAllMode && selectAllMode != 'none')
		selectAll()
	if (alwaysUse.valueOf()) {
		let Settings = app.user.Settings
		if (selectAllMode)
			Settings.AutoSelectMode = selectAllMode
		Settings.AutoSelectThreshold = threshold
		Settings.SingleGroupSelection = includeSingleGroups.valueOf()
		Settings.MultiGroupPooling = multiGroupPooling.valueOf()
		Settings.AdditiveInterventions = additiveInterventions.valueOf()
		Settings.AutomaticAutoSelect = turnOnAutomaticAutoSelect.valueOf()
		patch<User>('/portal/User/' + app.user.Id, {
			data: { Settings }
		})
	} else if (app.user.Settings?.AutomaticAutoSelect && !turnOnAutomaticAutoSelect.valueOf()) {
		let Settings = app.user.Settings
		Settings.AutomaticAutoSelect = false
		patch<User>('/portal/User/' + app.user.Id, {
			data: { Settings }
		})		
	}

}

export class AutoSelectDialog extends Dialog.with('.auto-select-dialog') {
	get defaults() {
		return {
			head: {
				titleText: 'Automatic Selection of Studies',
			},
			foot: {},
			size: '650px',
			id: 'auto-select-dialog',
		}
	}
	ready() {
		this.body.append(
			Div([
				Div([
					Span('Select All'),
					RangeInput({
						valueAsNumber: autoSelectThreshold,
						onchange() {
							setTimeout(() => {
								let settings = currentAnalysisSelections.settings.valueOf() || {}
								if (autoSelectThreshold < (settings.autoSelectThreshold ?? 20) ||
									!settings.autoSelectMode || settings.autoSelectMode == 'none')
									doAutoSelection.put(true)
							})
						},
						step: 5,
					}),
					Span('Strict Matching')
				], {
					title: 'Select a minimum threshold of the matching probability that is applied to each study, that will be used for choosing which studies to include when performing auto-selection.'
				}),
				Label('.select-all-selector', {
					classes: { selected: false },
					title: 'Automatically select all studies that are analyzable and have a matching probability above the threshold defined.'
				}, [
					Checkbox(doAutoSelection, {
						onchange() {
							if (!this.checked)
								weightedAutoSelection.put(false)
						}
					}),
					autoSelectThreshold.to(threshold => 'Auto-select studies with at least ' + threshold + '% match'),
				]),
				/*
				Button('.select-all-selector', {
					classes: { selected: selectAllModeVar.to(mode => mode == 'select') },
					content: autoSelectThreshold.to(threshold => 'At least ' +threshold + '% matching threshold'),
					onclick: () => {
						setMode('select', autoSelectThreshold.valueOf())
						this.hide()
					}
				})]),
			Div({
				display: reactive(app.user).to((user) => Boolean(user?.FeatureConfig?.Debug?.Enabled)),
			}, [
				Button('.select-all-selector', {
					classes: { selected: selectAllModeVar.to(mode => mode == 'weighted') },
					content: 'Select all and weight studies by matching probability',
					onclick: () => {
						setMode('weighted', 0)
						this.hide()
					}
				})]),
			Div([
				Button('.select-all-selector', {
					content: 'Unselect all studies',
					onclick: () => {
						setMode('none', autoSelectThreshold.valueOf())
						this.hide()
					}
				})]),*/
			Label('.select-all-selector.select-all-indented', {
				classes: { selected: false },
				title: 'In meta-analysis, studies are weighted by ' +
				'inverse variance, which is the observed measured variance plus an estimated ' +
				'variance/effect of unknown covariates (heterogeneity). However, traditionally these estimates ' +
				'assume zero a priori knowledge of heterogeneity, and are based only on between-study variance, which typically yields very poor ' +
				'estimates with no study-specific distinctions. DocAnalytics can often provide significantly better informed estimates of ' +
				'by using its matching estimate of how closely each individual study matches the question ' +
				'to estimate heterogeneity and the effect of covariates to weight studies (and their estimated variance with respect to the analysis) with more granularity and better informed priors. '
			}, [
				Checkbox(weightedAutoSelection, {
					onchange() {
						doAutoSelection.put(true)
						if (this.checked && autoSelectThreshold > 5)
							autoSelectThreshold.put(5)
					}
				}),
				'Weight studies by matching probability',
			]),
			Label('.select-all-selector', {
				classes: { selected: false },
				title: 'The percent match and matching probability settings will be applied for future questions when you auto-select studies.'
			}, [
				Checkbox(alwaysUse, {
					onchange() {
						if (!this.checked)
							turnOnAutomaticAutoSelect.put(false)
					}
				}),
				'Apply these settings for future questions.'
			]),
			Label('.select-all-selector.select-all-indented', {
				display: alwaysUse.to(always => always || Promise.resolve(app.user).then(user => !!user.Settings?.AutomaticAutoSelect)),
				//title: 'If selected this will automatically auto-select studies in new questions/analyses that you perform in the future.'
			}, [
				Checkbox(turnOnAutomaticAutoSelect, {
					onchange() {
						if (this.checked) {
							if (confirm('This will automatically auto-select studies whenever you ask a new question, instead of waiting for you to manually auto-select or select studies, are you sure you want this behavior?'))
								alwaysUse.put(true)
							else
								this.checked = false
						}
					},
				}),
				'Auto-select studies in future questions. All matching studies will be automatically selected for analysis.'
			]),
			Hr,
			Label('.select-all-selector', { classes:
				{ selected: false },
				title: 'DocAnalytics performs analysis estimating both relative effects and absolute effects for direct and network analysis, and ' +
					'single group/cohorts can be automatically included in analysis to add to absolute effect estimates for better accuracy and robustness. ' +
					'(Single groups/choorts are always included for automatic analysis.)'
			}, [
				Checkbox(includeSingleGroups),
				'Include cohorts for more robust absolute estimates'
			]),
			Label('.select-all-selector', {
				classes: { selected: false },
				title: 'This will auto-select and pool all groups within a study that DocAnalytics predicts ' +
				'match the searched treatments, which can help increase the total number of participants ' +
				'in a meta-analysis and improve robustness. If not selected, only one group will be selected per study for each selected treatment.'
			}, [
				Checkbox(multiGroupPooling),
				'Pool study groups'
			]),
			Label('.select-all-selector', {
				classes: { selected: false },
				title: 'This will allow a combination of multiple treatments to be selected in a group and analyzed by their additive effect. ' +
				'This can provide more robust and accurate results for analyzing combination treatments that consist of treatments that have ' +
				'mostly independent/additive effects (treatments that are not expected to significantly interact).'
			}, [
				Checkbox(additiveInterventions),
				'Use additive combination treatments'
			]),
		]))
		this.footer.leftControls.append(
			Button('.btn.secondary', {
				textContent: 'Cancel',
				onclick: () => {
					this.hide()
				},
			})
		)
		this.footer.rightControls.append(
			Button('.btn.primary', {
				textContent: doAutoSelection.to(select =>
					select ? 'Save and Select Studies' : 'Save'),
				onclick: () => {
					setMode(autoSelectThreshold.valueOf())
					this.hasChanges = false
					this.hide()
				},
			}),
		)
	}
	show(event) {
		this.hasChanges = all([autoSelectThreshold, multiGroupPooling, includeSingleGroups, weightedAutoSelection, alwaysUse], (autoSelectThreshold, multiGroupPooling, includeSingleGroups, weightedAutoSelection, alwaysUse) =>
			autoSelectThreshold != (currentAnalysisSelections.settings.autoSelectThreshold.valueOf() ?? 20) ||
			multiGroupPooling != currentAnalysisSelections.settings.multiGroupPooling.valueOf() ||
			additiveInterventions != currentAnalysisSelections.settings.additiveInterventions.valueOf() ||
			includeSingleGroups != currentAnalysisSelections.settings.singleGroupSelection.valueOf() ||
			weightedAutoSelection != (currentAnalysisSelections.settings.autoSelectMode == 'weighted') ||
			doAutoSelection.valueOf() ||
			alwaysUse.valueOf()
			)
		alwaysUse.put(false)
		autoSelectThreshold.put(currentAnalysisSelections.settings.autoSelectThreshold.valueOf() ?? 20)
		multiGroupPooling.put(currentAnalysisSelections.settings.multiGroupPooling.valueOf())
		additiveInterventions.put(currentAnalysisSelections.settings.additiveInterventions.valueOf())
		includeSingleGroups.put(currentAnalysisSelections.settings.singleGroupSelection.valueOf())
		weightedAutoSelection.put(currentAnalysisSelections.settings.autoSelectMode == 'weighted')
		doAutoSelection.put(false)
		turnOnAutomaticAutoSelect.put(!!(app.user.Settings?.AutomaticAutoSelect))
		super.show(event)
	}
	hide(event) {
		if (this.hasChanges.valueOf()) {
			if (!confirm('You made changes, are you sure you want to discard them?'))
				return
		}
		super.hide(event)
	}
}
